import {User} from '@common/auth/user';
import {useDisableTwoFactor} from '@common/auth/ui/two-factor/requests/use-disable-two-factor';
import {Trans} from '@common/i18n/trans';
import {TwoFactorStepperLayout} from '@common/auth/ui/two-factor/stepper/two-factor-stepper-layout';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {usePasswordConfirmedAction} from '@common/auth/ui/confirm-password/use-password-confirmed-action';
import {Button} from '@common/ui/buttons/button';

interface Props {
  user: User;
  onDisabled: () => void;
}
export function TwoFactorEnabledStep({user, onDisabled}: Props) {
  const disableTwoFactor = useDisableTwoFactor();
  const {withConfirmedPassword, isLoading: confirmPasswordIsLoading} =
    usePasswordConfirmedAction();
  const isLoading =
    disableTwoFactor.isPending ||
    confirmPasswordIsLoading;

  const actions = (
    <Button
      type="submit"
      variant="flat"
      color="danger"
      disabled={isLoading}
      onClick={() => {
        withConfirmedPassword(() => {
          disableTwoFactor.mutate(undefined, {
            onSuccess: () => {
              toast(message('Two-factor authentication has been disabled.'));
              onDisabled();
            },
          });
        });
      }}
    >
      <Trans message="Disable" />
    </Button>
  );

  return (
    <TwoFactorStepperLayout
      title={<Trans message="You have enabled two-factor authentication." />}
      description={
        <Trans message="Your account is now protected with two-factor authentication. You will be prompted to enter a code from your authenticator app each time you log in." />
      }
      actions={actions}
    />
  );
}
